var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('ArtisanGrid',{ref:"msgRecord",attrs:{"metaKey":"JyMsgRecord"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }